import { render, staticRenderFns } from "./my-checkbox.vue?vue&type=template&id=6e55141f&scoped=true&"
import script from "./my-checkbox.vue?vue&type=script&lang=js&"
export * from "./my-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./my-checkbox.vue?vue&type=style&index=0&id=6e55141f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55141f",
  null
  
)

export default component.exports